<template>
    <div class="hidden lg:block w-full lg:j-h-62 lg:min-h-[62px] bg-white lg:sticky lg:a-top-64 lg:j-left-0 z-2">
        <ul class="lg:j-w-1000 h-full mx-auto flex-between">
            <li
                v-for="{ id, name } in anchorList"
                :key="id"
                class="group cursor-pointer h-full flex-center"
                :class="{ 'active': id === currentId }"
                @click="scrollToAnchor(id, name)"
            >
                <span class="text-item">{{ name }}</span>
            </li>
        </ul>
    </div>
    <SwiperBanner id="boost-campaign" :isLogin="isLogin" />

    <!-- 宫格积分抽奖组件 -->
    <jbc-lucky-draw :shopifyShopId="shopId" showType="grid"></jbc-lucky-draw>

    <!-- 刮刮乐订阅抽奖组件 -->
    <jbc-lucky-scratch :shopifyShopId="shopId" showType="scratch" customTag="DYCJ-Subscribe"></jbc-lucky-scratch>

    <jbc-subscribe-draw
        platform="membership"
        :shopifyShopId="shopId"
        actType="subscribe"
        showType="grid"
    ></jbc-subscribe-draw>

    <div id="membership-benefits">
        <Benefits />
    </div>
    <div id="redeem-points">
        <Slogon :isLogin="isLogin" :point-amount="amountBalance.balancePoint" />
        <SwiperCard id="redeem-points_coupon" :title="t('member_index.redeem_points.category_tabs.coupon')" type="Coupon" :isLogin="isLogin" />
        <SwiperCard id="redeem-points_gift-card" :title="t('member_index.redeem_points.category_tabs.gift_card')" type="Gift-Card" :isLogin="isLogin" />
        <SwiperCard id="redeem-points_jackery-product" :title="t('member_index.redeem_points.category_tabs.jackery_products')" type="Products" :isLogin="isLogin" />
        <SwiperCard id="redeem-points_extras" :title="t('member_index.redeem_points.category_tabs.virtualCard')" type="VirtualCard" :isLogin="isLogin" />
    </div>
    <div id="earn-points">
        <EarnPoint :isLogin="isLogin" />
    </div>

    <div id="instructions">
        <HowItWork />
    </div>
    <div id="faq">
        <Faq />
    </div>
</template>

<script setup>
    import Benefits from './main/Benefits.vue'
    import Slogon from './main/Slogon.vue'
    import SwiperCard from './main/SwiperCard.vue'
    import EarnPoint from './main/EarnPoint.vue'
    import SwiperBanner from './main/SwiperBanner.vue'
    import HowItWork from './main/HowItWork.vue'
    import Faq from './main/Faq.vue'
    import { pullBalanceAmount, } from '@a/index'
    import { useWindowScroll, } from '@vueuse/core'
    import { gaPushDataLayer } from '@/utils/ga.js'
    import { useStore } from 'vuex';
    import { breakpointsTailwind, useBreakpoints, } from '@vueuse/core'

    const { t } = useI18n();
    const store = useStore();

    const breakpoints = useBreakpoints(breakpointsTailwind)
    const mobile = breakpoints.smaller('lg')

    const props = defineProps({
        isLogin: Boolean
    })

    // 获取 shopId
    const shopId = computed(() => store.getters.language.current?.shopify_shop_id);

    const userInfo = computed(() => store.getters.userInfo);

    const anchorList = reactive([
        { id: 'membership-benefits', name: t('member_index.section_tabs.membership_benefits') },
        { id: 'redeem-points', name: t('member_index.section_tabs.redeem_points') },
        { id: 'earn-points', name: t('member_index.section_tabs.earn_points') },
        { id: 'instructions', name: t('member_index.section_tabs.guide') },
        { id: 'faq', name: t('member_index.section_tabs.faq') },
    ])

    const currentId = ref('membership-benefits')
    const lockScroll = ref(false)
    const HEADER_HEIGHT = 64
    let timer = null
    const scrollToAnchor = (id, name) => {
        currentId.value = id
        lockScroll.value = true
        const offsetTop = document.getElementById(id).offsetTop
        window.scrollTo({
            top: offsetTop - HEADER_HEIGHT,
            behavior: 'smooth'
        })

        timer = setInterval(() => {
            if(y.value.toFixed() === (offsetTop - HEADER_HEIGHT).toFixed()) {
                lockScroll.value = false
                clearInterval(timer)
            }
        }, 50)

        // 发送GA事件
        const params = {
            jackery_id: userInfo.value.userName || "",
            position: name,
        }
        gaPushDataLayer(params)
    }

    // 获取 锚点偏移top 数组
    const getAnchorListOffsetTop = () => {
        return anchorList.reduce((prev, next) => {
            const top = document.getElementById(next.id).offsetTop
            prev = prev.concat([{ id: next.id, top, }])
            return prev
        }, [])
    }

    // 滚动监听
    const { y, } = useWindowScroll()
    let activeIndex = 0
    const watchScroll = () => {
        const offsetTops = getAnchorListOffsetTop()
        if (y.value >= offsetTops[activeIndex + 1]?.top - HEADER_HEIGHT) {
            activeIndex += 1
        }
        else if (y.value < offsetTops[activeIndex]?.top - HEADER_HEIGHT) {
            activeIndex = activeIndex === 0 ? 0 : activeIndex - 1
        }

        !lockScroll.value && (currentId.value = offsetTops[activeIndex].id)
    }


    const amountBalance = reactive({
        balancePoint: 0,
        comingSoonPoint: "",
    })

    const getAmountBalance = async () => {
        const { balancePoint, comingSoonPoint, } = await pullBalanceAmount()
        amountBalance.balancePoint = balancePoint
        amountBalance.comingSoonPoint = comingSoonPoint
    }

    // hash scroll
    const scrollToHashAnchor = () => {
        const id = location.hash.split('#')[1]?.split('?')[0]
        if (id) {
            currentId.value = id.includes('_') ? id.split('_')[0] : anchorList.map(({id}) => id).includes(id) ? id : currentId.value
            lockScroll.value = true
            const offsetTop = document.getElementById(id)?.offsetTop
            window.scrollTo({
                top: offsetTop - HEADER_HEIGHT - (id.includes('_') && !mobile.value ? 20 : 0),
                behavior: 'smooth'
            })

            timer = setInterval(() => {
                if(y.value.toFixed() === (offsetTop - HEADER_HEIGHT).toFixed()) {
                    lockScroll.value = false
                    clearInterval(timer)
                }
            }, 50)
        }
    }

    onMounted(() => {
        if(props.isLogin) {
            getAmountBalance()
        }

        nextTick(() => {
            setTimeout(() => {
                scrollToHashAnchor()
            }, 1500)
        });

        window.addEventListener('scroll', watchScroll, false)
    })
    onUnmounted(() => {
        window.removeEventListener('scroll', watchScroll, false)
    })
</script>
<style scoped>
    .text-item {
    @apply
        h-full flex-center text-#808080 text-16 lg:j-text-18 font-medium font-medium relative
        group-[.active]:(
            text-sub font-semibold
            after:block after:content-[''] after:absolute after:left-0 after:bottom-0
            after:lg:w-full after:lg:j-h-4 after:bg-primary
        )
    }
</style>
